/* eslint-disable */
var $fragment_refresh = {
    url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
    type: 'POST',
    success: function( data ) {
        if ( data && data.fragments ) {

            $.each( data.fragments, function( key, value ) {
                $( key ).replaceWith( value );
            });

            if ( $supports_html5_storage ) {
                sessionStorage.setItem( wc_cart_fragments_params.fragment_name, JSON.stringify( data.fragments ) );
                set_cart_hash( data.cart_hash );

                if ( data.cart_hash ) {
                    set_cart_creation_timestamp();
                }
            }

            $( document.body ).trigger( 'wc_fragments_refreshed' );
        }
    }
};
/* eslint-enable */

$(document).on('click', '.quantity .quantity__plus', function(e) {
    e.preventDefault();
    let input = $(this).closest('.quantity').find('input');
    let max = input.attr('max');

    if ( parseInt(input.val() ) < parseInt(max)  || !max )
        input.val(parseInt(input.val()) + 1).change();

    input.trigger('change');
})

$(document).on('click', '.quantity .quantity__minus', function(e) {
    e.preventDefault();
    let input = $(this).closest('.quantity').find('input');

    if (parseInt(input.val()) > 1) {
        input.val(parseInt(input.val()) - 1).change();
    }
    input.trigger('change');
})

$(document).on('input', '.quantity input', function() {
    let max = parseInt( $(this).attr('max') );

    if ( parseInt( $(this).val() ) > max ) {
        $(this).val(max);
        $(this).trigger('change');
    }
})

// $('[name="update_cart"]').click(function(e) {
//     e.preventDefault();
//
//     $.ajax( $fragment_refresh );
// })
if ($('select[name="billing_country"]').length > 0)
    $('select[name="billing_country"]').select2();

/* eslint-disable */
$('div.woocommerce').on('change', '.quantity input', function(){

    let var_id        = $(this).closest('.cart-item').attr('data-variation-id');
    let product_id    = $(this).closest('.cart-item').attr('data-product-id');
    let cart_item_key = $(this).closest('.cart-item').attr('data-cart-item');
    let quantity      = $(this).val();

    var data = {
        action: 'update_quantity',
        product_id: product_id,
        quantity: quantity,
        variation_id: var_id,
        cart_item_key: cart_item_key,
    };
    $.post(ajax.ajaxurl, data, function(response) {
        if (!response)
            return;
        response = JSON.parse(response);
        $('.woocommerce-cart-form').addClass('updating');
        $('.woocommerce-cart-form').html(response.fragments);

        console.log(response.checkout);
        if ( $('.js-checkout-wrap').length > 0 ) {
            console.log('inside checkout wrap');
            $('.js-checkout-wrap form.checkout').html(response.checkout);
            $('select[name="billing_country"]').select2();
        }

        $('.updating').fadeTo('400', '0.6').block({
            message: null,
            overlayCSS: {
                opacity: 0.6,
            },
        });

        $('.widget_shopping_cart, .updating').stop(true).css('opacity', '1').unblock();
        $('woocommerce-cart-form').load( function() {
            $('.woocommerce-cart-form').stop(true).css('opacity', '1').unblock();
            $(document.body).trigger('update_checkout');
            $(document.body).trigger('cart_page_refreshed');
            console.log('cart loaded');
        });

        $('.woocommerce-cart-form').removeClass('updating');

    })
});

// Ajax delete product in the cart
$(document).on('click', '.cart-item a.remove', function (e)
{
    e.preventDefault();

    let var_id            = $(this).closest('.cart-item').attr('data-variation-id');
    let product_id        = $(this).closest('.cart-item').attr('data-product-id');
    let cart_item_key     = $(this).closest('.cart-item').attr('data-cart-item');
    let product_container = $(this).closest('.cart-item');

    // Add loader
    product_container.block({
        message: null,
        overlayCSS: {
            cursor: 'none'
        }
    });
    $('.woocommerce-cart-form').addClass('updating');
    $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "product_remove",
            product_id: product_id,
            cart_item_key: cart_item_key
        },
        success: function(response) {
            if ( ! response || response.error )
                return;
            response = JSON.parse(response);

            $('.woocommerce-cart-form').html(response.fragments);
            if ( $('.js-checkout-wrap').length > 0 ) {
                $('.js-checkout-wrap form.checkout').html(response.checkout);
            }
            $('.updating').stop(true).css('opacity', '1').unblock();
            $(document.body).trigger('update_checkout');
            $(document.body).trigger('cart_page_refreshed');
            $('.woocommerce-cart-form').removeClass('updating');

        }
    });
});
/* esling-enable */

$(document).on('click', '.js-payment-method', function(e) {
    e.preventDefault();

    $('.js-payment-method').removeClass('active');
    $(this).addClass('active');
    let paymentAnchor = $(this).data('payment-method');

    $(paymentAnchor).trigger('click');
})

$(document).on('click', '.woocommerce-checkout .js-checkout-button', function(e) {
    e.preventDefault();

    $('.js-checkout-wrap').removeClass('d-none');
    $('.cart-wrap').addClass('d-none');
})


$(document).on('click', '.js-submit-checkout', function(e) {
    e.preventDefault();

    $('form.checkout').submit();
})
